export const STREET_API = "/streets";
export const IS_MAINTENANCE_API = "/is-maintenance";
export const getAddressPointsApi = (streetId: string) => {
  return `/address-points/${streetId}`;
};
export const getTrashScheduleApi = (addressId: string) => {
  return `/trash-schedule/${addressId}`;
};
export const getTrashSinglePdfApi = (addressId: string) => {
  return `/trash-schedule/${addressId}/pdf`;
};
